import { useEffect, useState } from "react";
import baseUrl from "../services/interceptor";
import Logs from "../shared/logs";
import { dataBinder } from "../shared/listWrapper";
import { FooterConfig } from "../shared/FooterConfig";
import { getSearchValue, saveOfflineData } from "../shared/helpers";
const useResources = (
  url,
  page,
  pageSize,
  sortColumn,
  sortColumnOrder,
  searchColumn,
  searchValue,
  filterListUpdate,
  reRender,
  filterType,
  searchArray,
  footerType,
  isSearch,
  searchReRender,
) => {
  const [
    { count, isLoading, data, finalFooterUpdate },
    setResources,
  ] = useState({
    count: 0,
    isLoading: true,
    data: [],
    finalFilterList: filterListUpdate,
    finalFooterUpdate: {},
  });
  let body = {
    pagination: {
      currentPage: page,
      pageSize: pageSize,
    },
    search:
      filterType === "diary" ||
      filterType === "history" ||
      filterType === "USERLIST" ||
      filterType === "CPTCODES" ||
      filterType === "claimantHistory" ||
      filterType === "claimantPayment" ||
      filterType === "claimFilter"
        ? searchArray
        : [{ criteriaName: searchColumn, value: getSearchValue(searchValue) }],
    sort: {
      columnName: sortColumn,
      orderBy: sortColumnOrder,
    },
  };
  useEffect(() => {
    (async () => {
      // Add data and loading
      setResources({
        isLoading: true,
        data: [],
      });
      await baseUrl
        .post(`${url}`, body)
        .then((response) => {
          const res = response.data.response;
          if (res === null) {
            localStorage.removeItem("summary");
          }
          setResources({
            page: page,
            count:
              url === "claim/payment/check/batch/view" ||
              url === "get/policy/endorseApprovalCSR"
                ? res.size
                : res.totalElements,
            pageSize: pageSize,
            data: saveOfflineData(res.content, url, searchValue),
            isLoading: false,
            sortColumn: sortColumn,
            sortColumnOrder: sortColumnOrder,
            criteriaName: searchColumn,
            value: searchValue,
            finalFooterUpdate: FooterConfig(res, footerType, searchValue),
            finalFilterList:
              filterListUpdate.length > 0
                ? dataBinder(filterListUpdate, res, filterType)
                : [],
            lenght: localStorage.setItem("LENGTH", res.content.length),
          });

          Logs.info(
            `Sucess ${url} Page: ${page} count: ${res.totalElements}`,
            "useResources",
          );
        })
        .catch((error) => {
          // Add data and loading
          setResources({
            isLoading: false,
            data: [],
          });
          Logs.error(JSON.stringify(error), "Policies");
        });
    })();
  }, [
    url,
    page,
    pageSize,
    sortColumn,
    sortColumnOrder,
    searchColumn,
    searchValue,
    reRender,
    searchArray,
    searchReRender,
  ]);

  return [data, count, isLoading, finalFooterUpdate];
};

export default useResources;
